import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/compat/auth';
// import { TOKEN_NAME } from '@app/shared/services/auth.service';


/**
 * Interceptor for adding the firebase authentication Bearer token to any request that is performed.
 */
@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(
    private afAuth: AngularFireAuth,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.handleAccess(req, next));
}

private async handleAccess(request: HttpRequest<any>, next: HttpHandler):
  Promise<HttpEvent<any>> {
    try {
        const token = await (await this.afAuth.currentUser)?.getIdToken()
        let changedRequest = request;
        // HttpHeader object immutable - copy values
        const headerSettings: {[name: string]: string | string[]; } = {};
    
        for (const key of request.headers.keys()) {
          headerSettings[key] = request.headers.getAll(key) as string|string[];
        }
        if (token) {
        headerSettings['Authorization'] = 'Bearer ' + token;
        }
        headerSettings['Content-Type'] = 'application/json';
        const newHeader = new HttpHeaders(headerSettings);
    
        changedRequest = request.clone({
          headers: newHeader
        });
        return next.handle(changedRequest).toPromise();   
    } catch (error) {
        console.error(error)
        return next.handle(request).toPromise()
    }
}
}